import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const genericLookup = (payload: { key: string; searchText?: string }) => {
  const query = queryString.stringify({ key: payload.key, search: payload.searchText });
  return http.get(`${API_ENDPOINTS.configLookup}?${query}`);
};

const geoLookup = (payload: { type: 'city' | 'state' | 'country'; searchText?: string }) => {
  const query = queryString.stringify({ type: payload.type, search: payload.searchText });
  return http.get(`${API_ENDPOINTS.geoLookup}?${query}`);
};

const CommonService = {
  genericLookup,
  geoLookup,
};

export default CommonService;
